/**
 * customer (거래처) orval 래퍼
 */
import { customInstance } from "../custom-instance";
import { validateArrayWithSchema } from "@erp/shared/utils/https/zod-validation";
import { z } from "zod";
// ── 스키마 & 타입 (Company) ──
export const CustomerCompanyResponseSchema = z
    .object({
    id: z.coerce.number(),
    name: z.string(),
    representative: z.string().nullable(),
    registrationNumber: z.string().nullable(),
    address: z.string().nullable(),
    phone: z.string().nullable(),
    fax: z.string().nullable(),
    paymentTerms: z.string().nullable(),
    accountNumber: z.string().nullable(),
})
    .strip();
// ── API 함수 (Company) ──
export const getCustomerCompanies = async (search) => {
    const data = await customInstance({
        url: "/customer-company",
        method: "GET",
        params: search ? { search } : {},
    });
    return validateArrayWithSchema(CustomerCompanyResponseSchema, data);
};
export const getCustomerCompanyById = async (id) => {
    const data = await customInstance({
        url: `/customer-company/${id}`,
        method: "GET",
    });
    return CustomerCompanyResponseSchema.parse(data);
};
export async function postCustomerCompany(body) {
    const data = await customInstance({
        url: "/customer-company",
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: body,
    });
    return CustomerCompanyResponseSchema.parse(data);
}
export const patchCustomerCompany = async (id, body) => {
    return customInstance({
        url: `/customer-company/${id}`,
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        data: body,
    });
};
export async function deleteCustomerCompany(id) {
    return customInstance({
        url: `/customer-company/${id}`,
        method: "DELETE",
    });
}
// ── API 함수 (Person) ──
export async function getCustomerPersons(companyId) {
    return customInstance({
        url: "/customer-person",
        method: "GET",
        params: { companyId },
    });
}
export async function getCustomerPersonById(id) {
    return customInstance({
        url: `/customer-person/${id}`,
        method: "GET",
    });
}
export async function postCustomerPerson(body) {
    return customInstance({
        url: "/customer-person",
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: body,
    });
}
export async function patchCustomerPerson(id, body) {
    return customInstance({
        url: `/customer-person/${id}`,
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        data: body,
    });
}
export async function deleteCustomerPerson(id) {
    return customInstance({
        url: `/customer-person/${id}`,
        method: "DELETE",
    });
}
// ── SDK 객체 ──
export const customerApi = {
    getCustomerCompanies,
    getCustomerCompanyById,
    postCustomerCompany,
    patchCustomerCompany,
    deleteCustomerCompany,
    getCustomerPersons,
    getCustomerPersonById,
    postCustomerPerson,
    patchCustomerPerson,
    deleteCustomerPerson,
};
